import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, Chip, LinearProgress, Dialog,DialogTitle, DialogContent, DialogContentText } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite'

function App(props) {
  const { schoolId } = props.match.params;
  const [sponsorList, setSponsorList] = useState(undefined);
  const [listBusinessTip, setListBusinessTip] = useState(false);

  useEffect(() => {
    axios.get(`/api/sponsors/@school/${schoolId}?status=APPROVED`).then(function (response) {
        debugger;
      if (response.status === 200) {
        setSponsorList(response.data);
      }
    }).catch(
           function (error) {
            if(error.response && error.response.data && error.response.data.type === 'authentication.missing'){
                 var _redirectUrl = encodeURIComponent(window.location.href);
                 window.location.href = '/signin.html?redirect='+_redirectUrl;
            }
             return Promise.reject(error)
           }
         );
    axios.put('/api/users/@bizListingsAccessTime')
  }, [schoolId])

  const cardClick = (sponsor) => {
    props.history.push('/sponsor-detail/' + sponsor._id, {});
    props.history.go();
  }

  const renderSponsor = (sponsor) => {
    const coupons = sponsor.businessInfo.coupons && sponsor.businessInfo.coupons.map(coupon => <div key={coupon.title} className="card-item-description">{coupon.title}</div>)
    return <Card key={sponsor._id} className="card-item" onClick={() => cardClick(sponsor)}>
      <CardContent className="card-item-content">
        <img height="60" alt='logo' src={sponsor.businessInfo.logo90||sponsor.businessInfo.logo} className="card-item-img" />
        <div>
          <div className="card-item-title">{sponsor.businessInfo.name}</div>
          {coupons}
        </div>
        <div style={{position:'absolute', right: '20px', textAlign: 'center'}}>
            <div><FavoriteIcon color="secondary" /> </div>
        {sponsor.recommendCount}
        </div>
        {sponsor.ownedByParent && <span className="card-item-label ka-label">Parent Owned</span>}
      </CardContent>
    </Card>;
  }

  if (sponsorList === undefined) {
    return <LinearProgress style={{ marginTop: '150px' }} />
  }

  const checkLabels = [  ];
  return (
    <div>
      <div className="clip-list">
        {checkLabels.map(label => {
          return <Chip label={label.title} />
        })}
      </div>
      {sponsorList.map(renderSponsor)}
      {sponsorList && sponsorList.length ==0 && <div style={{textAlign: "center"}}>
      <div>
      No Business Listings.
      </div>
      <div>
       Be the first one to list your business here.
       </div>
      </div>}

      <div style={{marginTop: '20px', textAlign: 'center', fontSize: '.8em'}}>
        <a style={{textDecoration: "none", color: "#0DA563", fontSize: '18px'}} onClick={() => setListBusinessTip(true)}>List Your Business &<br/>Help Your Community </a>

          {sponsorList && sponsorList.length > 0 &&  <div> <p>&nbsp;</p> Disclaimer: Listings are not endorsed by your school, your parent organization, or Konstella. </div>}
      </div>
      <Dialog
        open={listBusinessTip}
        onClose={() => setListBusinessTip(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText style={{textAlign: 'center'}} id="alert-dialog-description">
          Please create your business at<br/>
		<a style={{textDecoration: "none", color: "#0DA563"}} href="https://www.konstella.com/app/manage/sponsors">konstella.com/app/manage/sponsors</a><br/> 
		from your computer or tablet.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default App;
